import { FC, useContext, useState, useMemo, useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import styles from '../index.module.less';
// import V2Title from '@/common/components/Feedback/V2Title';
import V2Table from '@/common/components/Data/V2Table';
import V2Operate from '@/common/components/Others/V2Operate';
import { isArray, isNotEmptyAny, refactorPermissions } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import cs from 'classnames';
import CreatePointMatching from './CreatePointMatching';
import ChancePointDetail from '@/common/components/business/ExpandStore/ChancePointDetail';
import ChanceCreateDrawer from '@/common/components/business/ExpandStore/ChanceCreateDrawer';
import SelectTemplateModal from '@/common/components/business/ExpandStore/ChanceCreateDrawer/SelectTemplateModal';
import { associateTask, checkApprovalForm, passTaskChancepoint, taskChancePointInfo, taskTypeList } from '@/common/api/expandStore/expansiontask';
import CreateSpotApproval from '@/common/components/business/ExpandStore/TaskDetailCommon/CreateSpotApproval';
import ApproverDetailDrawer from '@/views/expandstore/pages/approver/components/DetailDrawer';
import ReleaseChance from '@/common/components/business/ExpandStore/ReleaseChance';
import { V2Confirm } from '@/common/components/Others/V2Confirm';
import { Button, Image } from 'antd';
import {
  ProtectStatusColor,
  ProtectString,
  ChancePointStatusColor,
  ApprovalStatus
} from '@/common/components/business/ExpandStore/ts-config';

import V2Empty from '@/common/components/Data/V2Empty';
// import ContractSignModal from '@/views/expandstore/pages/shop/components/ContractSignModal';
// import { bigdataBtn } from '@/common/utils/bigdata';
import UserInfoContext from '@/layout/context';
import { globalAlias } from '@/common/utils/ways';
import ShopEditDrawer from '@/views/expandstore/pages/shopEdit/Drawer';
import { useBigdataFn } from '@/common/utils/bigdata';
import AreaProtectionDrawer from '@/common/components/business/AreaProtection/detail';
import { getTemplateLists } from '@/common/api/expandStore/chancepoint';
import { useSelector } from 'react-redux';
import { getChancepointAllFileds, getFieldWithIdentification, } from '@/common/components/business/DynamicComponent/chancepointTools';
import DirectPassSpotApproval from '../../TaskDetailCommon/DirectPassSpotApproval';
import { meituanReportYHTIdentification } from '../../../DynamicComponent/customize';
import { ControlType } from '../../../DynamicComponent/config';
import { ShopEditType } from '@/views/expandstore/pages/shopEdit/ts-config';

// 无址时「点位评估」按钮文案调整为「发起签约流程」
const TextYHTNoAddressCreateSpot = '发起签约流程';

/**
 * 拓店任务-详情-点位匹配情况
 * @Description 拓店任务：加盟（益禾堂、非益禾堂）
 */
const PointMatching: FC<{
  /** 任务ID */
  id: number;
  /** 任务详情 */
  taskDetail: any;
  /** 匹配点位信息 */
  chancePointInfo: any;
  /** 设置机会点数据 */
  setChancePointInfo:Function;
  /** 是否只能查看（审批详情时只能查看） */
  isView: boolean;
  /** 外部新增按钮是否可见 */
  showAddBtn?: boolean;
  refresh: any;
  hideOperate?: boolean;
  /** 展示外部的新增机会点按钮文案，为空则不展示按钮 */
  setAddPointButtonText?: any,
  ref?: any,
}> = forwardRef(({
  id,
  taskDetail,
  chancePointInfo,
  isView,
  showAddBtn = true,
  setChancePointInfo,
  refresh,
  hideOperate, // 是否隐藏操作按钮
  setAddPointButtonText,
}, ref) => {

  useImperativeHandle(ref, () => ({
    addChancePoint: methods.handleCreatePointMatching,
  }));

  const editRef: any = useRef();
  const createPointMatchingRef: any = useRef();
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [filters, setFilters] = useState<any>(); // 筛选参数
  const [showCreateModal, setShowCreateModal] = useState<boolean>(false); // 是否显示关联弹窗
  const [selectTemplateVisible, setSelectTemplateVisible] = useState<boolean>(false);
  const [templateList, setTemplateList] = useState<any[]>([]);
  const [pointId, setPointId] = useState<number>(); // 机会点id
  const [showPointDetail, setShowPointDetail] = useState<boolean>(false); // 是否显示机会点详情弹窗
  const [areaProtectOpen, setAreaProtectOpen] = useState<boolean>(false);// 发起保护
  const [refreshDetail, setRefreshDetail] = useState<number>(0); // 刷新机会点详情
  const [formDrawerData, setFormDrawerData] = useState<any>({
    open: false,
    templateId: '', // 模板id
    id: '', // 编辑时的id
  }); // 机会点详情上的编辑
  const [drawerData, setDrawerData] = useState<any>({
    open: false,
    templateId: '', // 模板id
    id: '', // 编辑时的id
    expandStoreData: null, // 拓店任务相关信息
  }); // 完善点位评估编辑
  const [releaseData, setReleaseData] = useState<any>({
    open: false,
    id: '', // 解除绑定时的任务id
  }); // 解除绑定弹窗
  const [approvalModal, setApprovalModal] = useState<any>({
    show: false,
    id: undefined, // 机会点ID
    type: undefined, // 审批类型
    typeValue: undefined, // 审批子类
  }); // 提交审批弹窗
  const [passModal, setPassModal] = useState<any>({
    show: false,
    taskId: id,
    fields: [],
    chancePointId: undefined, // 机会点ID
    mtProperty: undefined,
    estimateSale: undefined, // 预测营业额
  }); // 提交审批弹窗
  const [contractApprovalData, setContractApprovalData] = useState<any>({
    id: null,
    open: false,
  }); // 合同签约审批详情
  const [taskTypes, setTaskTypes] = useState<any[]>([]);
  const { tenantInfo } = useContext(UserInfoContext); // 租户信息
  const { globalAliasItemVOs } = tenantInfo;
  const tenantCheckData = useSelector((state: any) => state.common.tenantCheck);
  const isYhtTaskTypeNoAddressRef: any = useRef(null);

  const chancepointAlias = useMemo(() => {
    return globalAlias(globalAliasItemVOs);
  }, [globalAliasItemVOs]);

  /**
   * @description 控制table表头刷新的key
   * @return
   */
  const tableKey = useMemo(() => {
    return (isView ? 1 : 0) + (tenantInfo?.protectFlag ? 2 : 0);
  }, [isView, tenantInfo?.protectFlag]);

  const isYiHeTang = useMemo(() => {
    return !!tenantCheckData?.isYiHeTang;
  }, [tenantCheckData]);

  /**
   * @description 益禾堂,且能展示有地址/无址的版本
   */
  const isYesNoAddressYiHeTang = useMemo(() => {
    const res = isYiHeTang && isArray(taskTypes) && taskTypes.some((itm: any) => itm.typeCode === 'hadAddress');
    return res;
  }, [isYiHeTang, taskTypes]);

  /**
   * @description 是否益禾堂有址选址
   *
   *   益禾堂-拓店任务-有址审批，使用自动关联，在本页面内跳转新增机会点创建完成后自动关联
   *   自动关联展示“添加机会点”
   */
  const isYhtTaskTypeHasAddress = useMemo(() => {
    return isYesNoAddressYiHeTang && taskDetail.taskTypeCode === 'hadAddress';
  }, [isYesNoAddressYiHeTang, taskDetail]);

  /**
   * @description 是否益禾堂无址匹址
   *
   *   益禾堂-拓店任务-无址匹址，使用手动关联审批通过的机会点
   *   手动关联展示“关联机会点”
   */
  const isYhtTaskTypeNoAddress = useMemo(() => {
    const res = isYesNoAddressYiHeTang && taskDetail.taskTypeCode === 'noneAddress';
    isYhtTaskTypeNoAddressRef.current = res;
    return res;
  }, [isYesNoAddressYiHeTang, taskDetail]);

  /**
   * @description 是否益禾堂有址、无址以外的其他任务类型
   *
   *   益禾堂-拓店任务-其他任务类型，不出现任何操作按钮
   */
  const isYhtTaskTypeOther = useMemo(() => {
    return isYesNoAddressYiHeTang && !['hadAddress', 'noneAddress'].includes(taskDetail.taskTypeCode);
  }, [isYesNoAddressYiHeTang, taskDetail]);

  /**
   * @description 添加文案，与是否自动关联及别名有关
   */
  const addText = useMemo(() => {
    if (isYesNoAddressYiHeTang) {
      return isYhtTaskTypeHasAddress ? `创建${chancepointAlias}` : isYhtTaskTypeNoAddress ? `关联${chancepointAlias}` : '';
    }
    return `关联${chancepointAlias}`;
  }, [isYesNoAddressYiHeTang, isYhtTaskTypeHasAddress, isYhtTaskTypeNoAddress, chancepointAlias]);

  /** 展示内部列表上方的新增按钮 */
  const showInnerAddButton = !isView && showAddBtn && !!chancePointInfo?.objectList?.length;

  useEffect(() => {
    getTaskTypeList();
  }, []);
  useEffect(() => {
    // 为了和内部显示逻辑统一
    setAddPointButtonText?.(chancePointInfo?.objectList?.length ? addText : '');
  }, [chancePointInfo?.objectList, addText]);

  /**
   * @description 获取该租户配置的所有任务类型
   */
  const getTaskTypeList = () => {
    taskTypeList().then((data) => {
      setTaskTypes(isArray(data) ? data : []);
    });
  };

  /**
   * @description 是否仅允许关联审批通过的机会点
   *
   *   益禾堂无址任务类型、或者租户设置了仅可关联审批过的机会点
   */
  const onlyApprovedChance = useMemo(() => {
    return isYhtTaskTypeNoAddress || !!tenantInfo?.onlyAllowRelatedApprovalPoint;
  }, [isYhtTaskTypeNoAddress, tenantInfo]);

  useEffect(() => {
    // 目前只有益禾堂且有址选址时需要提前获取
    if (!isYhtTaskTypeHasAddress) return;

    getTemplateLists().then((result) => {
      setTemplateList(result.map((item) => ({ label: item.templateName, value: item.id })));
    });
  }, [isYhtTaskTypeHasAddress]);

  const basicColumns = [
    {
      key: 'shopImgUrls',
      title: '点位图片',
      width: 90,
      render: (value) =>
        <Image
          width={70}
          height={52}
          style={{ borderRadius: 2, }}
          src={isArray(value) && value.length
            ? value?.[0]
            : `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/task/ic_place_noimg.png` }
        />
    },
    {
      key: 'name',
      title: '点位名称',
      width: 'auto',
      dragChecked: true,
      render: (value, record) => {
        return isNotEmptyAny(value) ? (
          <span
            // className={!isView ? styles.highlight : ''}
            className={hideOperate ? '' : styles.highlight}
            onClick={() => methods.onClickDetail(record)}
          >
            {value}
          </span>
        ) : (
          '-'
        );
      },
    }, {
      key: 'address',
      title: '详细地址',
      width: 402,
      importWidth: true,
      dragChecked: true,
      render: (value) => isNotEmptyAny(value) ? value : '-',
    }, {
      key: 'statusName',
      title: '状态',
      width: 'auto',
      dragChecked: true,
      render: (value, record) => isNotEmptyAny(value) ? <span
        style={{
          color: ChancePointStatusColor[record?.status]
        }}
      >{value}</span> : '-',
    },
    // {
    //   key: 'process',
    //   title: '填写进度',
    //   width: 'auto',
    //   render: (value, record) => (
    //     <>
    //       <Progress
    //         percent={record.requiredNum / record.requiredTotalNum * 100}
    //         showInfo={false}
    //         trailColor='#ddd'
    //         style={{
    //           width: '64px',
    //           marginRight: 8
    //         }}/>
    //       {record.requiredNum}/{record.requiredTotalNum}
    //     </>
    //   )
    // },
  ];

  const protectColumn = {
    key: 'protectStatusName',
    title: '保护状态',
    width: 'auto',
    dragChecked: true,
    render: (value, record) => {
      const protectStatusName = record?.protectInfo?.statusName;
      if (isNotEmptyAny(protectStatusName)) {
        return <span style={{
          color: ProtectStatusColor[protectStatusName] || '#666666'
        }}>{protectStatusName}</span>;
      } else {
        // 区域保护可用时，显示未保护，否则显示-
        const canApplyProtect = isArray(record?.processButton) && !!record?.processButton.find((itm: any) => itm.code === 'standardChancePoint:submitProtect');
        return canApplyProtect ? <span style={{
          color: ProtectStatusColor[ProtectString.Off]
        }}>{ProtectString.Off}</span> : '-';
      };
    }
  };

  const operateColumn = {
    key: 'processButton',
    title: '操作',
    width: 'auto',
    dragChecked: true,
    render: (value, record) => {
      const operateList = refactorPermissions(isArray(value) ? value.map(itm => ({ ...itm, event: itm.code })) : []);

      return !hideOperate && operateList.length ? (<V2Operate
        operateList={operateList}
        onClick={(btn: any) => methods[btn.func](btn, record)}
      />) : '-';
    }
  };

  const defaultColumns = tenantInfo && tenantInfo?.protectFlag ? [...basicColumns, protectColumn, operateColumn] : [...basicColumns, operateColumn];

  const methods = useMethods({

    // 点位评估
    async handleEvaluationCreateApproved(item, record) {
      if (isView || !item.isHighlight) return; // 审批详情时不可编辑，或者按钮不高亮的内容不可点击

      if (isYhtTaskTypeNoAddressRef.current) {
        // 益禾堂无址匹址时，点位评估直接通过
        const res = await getChancepointAllFileds(record.id);
        // 美团报告
        const mtreportProperty = getFieldWithIdentification(res, meituanReportYHTIdentification);
        // 竞品均值
        const props = res.filter((itm) => ([
          ControlType.ESTIMATE_SALES_MT_MEAN_YHT.value,
          ControlType.ESTIMATE_SALES_MT_MAX_YHT.value,
        ].includes(itm.controlType)));
        const estimateSaleProps = isArray(props) && props.length ? props : null; // 无数据直接设置null方便判断

        if (mtreportProperty || estimateSaleProps) {
          // 无址带表单-需要展示美团报告
          setPassModal({
            show: true,
            taskId: id,
            chancePointId: record.id,
            fields: res,
            mtProperty: mtreportProperty, // 美团报告数据
            estimateSale: estimateSaleProps, // 预测营业额属性
          });
        } else {
          // 无址带不带表单
          V2Confirm({
            content: `确定${TextYHTNoAddressCreateSpot}？`,
            onSure() {
            // 益禾堂无址匹址时，点位评估直接通过
              passTaskChancepoint({
                id,
                chancePointId: record.id
              }).then((res: any) => {
                res && setFilters({});
              });
            }
          });
        }
        return;
      }

      const res = await checkApprovalForm({
        type: item.approvalType,
        typeValue: item.approvalTypeValue,
        relationId: record.id
      });
      if (res) {
        // 必填校验通过的时候打开发起审批弹窗
        setApprovalModal({
          show: true,
          type: item.approvalType,
          typeValue: item.approvalTypeValue,
          id: record.id
        });
      } else {
        // 必填校验未通过
        V2Confirm({
          onSure: (modal: any) => {
            setDrawerData({
              open: true,
              templateId: '', // 模板id
              id: record.id, // 编辑时的id
              expandStoreData: item, // 拓店任务相关信息
            });
            modal.destroy();
          },
          okText: '去补充',
          title: '信息提示',
          content: `您的${chancepointAlias}暂未填写完整，请去补充${chancepointAlias}信息` });
      }
    },
    /** 表单内提交点位评估后续操作 */
    closeApprovalModal() {
      if (drawerData.open) {
        setDrawerData({
          open: false,
          templateId: '', // 模板id
          id: '', // 编辑时的id
          expandStoreData: null // 拓店任务相关信息
        });
      }
    },
    // 合同签约
    handleContractCreateApproved(item, record) {
      const { approvalId, approvalStatus } = record?.contractApprovingInfo || {};
      if (approvalId && approvalStatus === ApprovalStatus.Untreated) {
        // 签约审批中
        setContractApprovalData({
          id: approvalId,
          open: true,
        });
      } else {
        // 还未生成审批，则允许发起审批，或直接签约通过
        setPointId(record.id);
        // setSignVisible(true);
        editRef.current.init({
          id: record.id,
          type: ShopEditType.Sign,
        });
        bigdataFn('e85b86cd-7d3a-4b8e-948b-c18e341bac56', '拓店任务详情-签约', '点击了拓店任务详情-签约', { op_block: '拓店任务管理', op_event: ``, });
      }
    },
    // 保护
    handleSubmitProtect(item, record) {
      setPointId(record.id);
      setAreaProtectOpen(true);
    },
    // 解绑
    handleRelease(item, record) {
      setReleaseData({
        open: true,
        id: record.id,
      });
    },
    // 编辑
    handleEdit(item, record) {
      setFormDrawerData({
        id: record.id,
        open: true,
        templateId: '',
      });
    },

    /**
     * @description 加载表格数据
     */
    loadData: async() => {
      if (!id) return;
      const data = await taskChancePointInfo({ id });

      const list = isArray(data.objectList) ? data.objectList.map(itm => {
        const hasReleaseBtn = !!itm.releaseButton && !isView;
        const releaseBtn = {
          'sort': null,
          'name': '取消关联',
          'approvalTypeValue': null,
          'approvalType': null,
          'approvalFlowId': null,
          'code': 'release',
          'isComplete': false,
          'isHighlight': true
        };
        const btns = (hasReleaseBtn ? [...(itm.processButton || []), releaseBtn] : itm.processButton).map(btn => ({
          ...btn,
          name: isYhtTaskTypeNoAddressRef.current && (btn.code === 'evaluationCreateApproved') ? TextYHTNoAddressCreateSpot : btn.name
        }));
        return {
          ...itm,
          processButton: btns
        };
      }) : [];

      setChancePointInfo(data);
      setIsLoading(false);
      return {
        dataSource: list,
        count: data?.totalNum > 0 ? data?.totalNum : 0,
      };
    },

    /**
     * @description 点击名称查看详情
     * @param record 当前选中点击某一行的数据
     */
    onClickDetail: (record) => {
      // if (isView) return;
      if (hideOperate) return;
      setPointId(record.id); // 机会点ID
      setShowPointDetail(true); // 显示弹窗
    },

    /** 打开详情页时的编辑表单的刷新详情页 */
    updateHandle: () => {
      const curVal = refreshDetail + 1;
      setRefreshDetail(curVal);
    },

    /**
     * @description 机会点创建成功后，自动关联机会点
     * @param chanceId
     */
    autoAssiocateChance: (chanceId) => {
      associateTask({ id, chancePointIds: [chanceId] }).then(() => {
        refresh();
        setFilters({});
        createPointMatchingRef?.current?.onLoad();
      });
    },

    /**
     * @description 关联机会点/创建机会点
     */
    handleCreatePointMatching: () => {
      if (isYhtTaskTypeHasAddress) {
        /* 益禾堂有址选址，创建后自动关联
          单一机会点模板：直接打开创建机会点抽屉
          多个机会点模板：展示选择模板弹框
        */
        templateList?.length === 1 ? setFormDrawerData && setFormDrawerData({
          templateId: templateList[0]?.value,
          open: true,
        }) : setSelectTemplateVisible(true);
        return;
      } else if (isYhtTaskTypeOther) {
        // 益禾堂有址、无址以外的任务类型
        return;
      }

      setShowCreateModal(true);
      // bigdataBtn('b3561739-7a76-5764-8013-7c0fcf77b2ca', '拓店任务', '关联机会点', `点击了关联机会点`);
      bigdataFn('7f86d97e-6ddc-403c-9980-2dc72c598dab', '拓店任务详情-关联机会点', '点击了拓店任务详情-关联机会点', { op_block: '拓店任务管理', op_event: ``, });
    },

  });

  return (
    <>
      {
        isYhtTaskTypeOther ? <V2Empty
          className='mt-100'
          customTip={'请修改“任务类型”后重试'}
        /> : <div className={styles.pointMatching} >
          {/* <V2Title type='H2' text='匹配机会点情况' divider/> */}
          {!!showInnerAddButton && <span className={styles.addInfo} onClick={methods.handleCreatePointMatching}>+ {addText}</span>}
          <V2Table
            key={tableKey}
            filters={filters}
            loading={false}
            rowKey='id'
            type='easy'
            pagination={false}
            defaultColumns={defaultColumns}
            hideColumnPlaceholder
            onFetch={methods.loadData}
            className={cs(chancePointInfo?.objectList?.length ? '' : styles.hide, 'mt-12')}
          />
          {/* loading结束且没数据才会显示空状态 */}
          { chancePointInfo?.objectList?.length || isLoading ? <></> : <V2Empty
            className='mt-100'
            customTip={!isView ? <Button
              onClick={methods.handleCreatePointMatching}
              type='primary'>{addText}</Button> : '暂无点位'}
          />
          }
        </div>
      }

      {/* 匹配机会点 */}
      <CreatePointMatching
        id={id}
        ref={createPointMatchingRef}
        refresh={() => {
          refresh();
          setFilters({});
        }}
        chancepointAlias={chancepointAlias}
        hideAddBtn={isYhtTaskTypeNoAddress}
        isYiHeTang={isYiHeTang}
        onlyApprovedChance={onlyApprovedChance}
        open={showCreateModal}
        setOpen={setShowCreateModal}
        setFormDrawerData={setFormDrawerData}
      />

      {/* 模版选择框  */}
      <SelectTemplateModal
        setVisible={setSelectTemplateVisible}
        visible={selectTemplateVisible}
        chancepointAlias={chancepointAlias}
        setFormDrawerData={setFormDrawerData}
      />

      {/* 机会点详情 */}
      <ChancePointDetail
        taskId={id}
        projectSearchDefaults={{
          city: taskDetail?.modelClusterInfo ? [taskDetail.targetProvinceId, taskDetail.targetCityId] : undefined,
          projectName: taskDetail?.modelClusterInfo?.modelClusterName,
          longitude: taskDetail?.modelClusterInfo?.centerLng,
          latitude: taskDetail?.modelClusterInfo?.centerLat,
        }}
        pointId={pointId}
        detailVisible={showPointDetail}
        setDetailVisible={setShowPointDetail}
        setFormDrawerData={setFormDrawerData}
        chancepointAlias={chancepointAlias}
        refreshDetail={refreshDetail}
        formDrawerData={formDrawerData}
        needAssiocateChance={isYhtTaskTypeHasAddress}
        updateHandle={methods.updateHandle}
        onSearch={(chanceId) => {
          if (isYhtTaskTypeHasAddress && !formDrawerData.id && chanceId) {
            // 有址类型+新建机会点成功后自动关联（不能是编辑场景）
            methods.autoAssiocateChance(chanceId);
          } else {
            refresh();
            setFilters({});
            createPointMatchingRef?.current?.onLoad();
          }
        }}
      />

      {/* 完善点位评估时打开机会点编辑弹窗 */}
      <ChanceCreateDrawer
        drawerData={drawerData}
        isExpandStoreTaskIn
        handleExpandStoreApproved={methods.handleEvaluationCreateApproved}
        onSearch={() => {
          refresh();
          setFilters({});
        }}
        handleEditSuccessed={() => {
          refresh();
          setFilters({});
        }}
        closeHandle={() =>
          setDrawerData({
            open: false,
            templateId: '', // 模板id
            id: '', // 编辑时的id
            expandStoreData: null, // 拓店任务相关信息
          })
        }
      />

      {/* 提交审批弹窗 */}
      {/* 益禾堂有址时的点位评估 */}
      <CreateSpotApproval
        refresh={() => {
          refresh();
          setFilters({});
          methods.closeApprovalModal();
        }} // 刷新
        approvalModal={approvalModal}
        setApprovalModal={setApprovalModal}
        isYihetang={isYiHeTang}
      />
      {/* 益禾堂无址发起点位评估 */}
      <DirectPassSpotApproval
        refresh={() => {
          refresh();
          setFilters({});
        }} // 刷新
        passModal={passModal}
        setPassModal={setPassModal}
        title={TextYHTNoAddressCreateSpot}
      />
      {/* 合同签约 */}
      <ShopEditDrawer ref={editRef} reload={() => {
        refresh();
        setFilters({});
      }}/>
      {/* <ContractSignModal visible={signVisible} setVisible={setSignVisible} id={pointId} onRefresh={() => {
        refresh();
        setFilters({});
      }}/> */}
      {/* 区域保护弹窗 */}
      <AreaProtectionDrawer
        id={pointId}
        open={areaProtectOpen}
        setOpen={setAreaProtectOpen}
        updateHandle={() => {
          refresh();
          setFilters({});
        }}
      />
      {/* 解除绑定弹窗 */}
      <ReleaseChance
        chancepointAlias={chancepointAlias}
        modalData={releaseData}
        setModalData={setReleaseData}
        refresh={() => {
          refresh();
          setFilters({});
        }}
      />
      {/* 审批详情抽屉 */}
      <ApproverDetailDrawer
        id={contractApprovalData?.id}
        open={contractApprovalData?.open} // 是否可见
        setOpen={(op) => {
          setContractApprovalData((state) => ({
            ...state,
            open: op,
          }));
        }}
        onRefresh={() => {
          refresh();
          setFilters({});
        }}
      />
    </>

  );
});

export default PointMatching;
